export const SL_UNREAD_DATE = '9999-12-31';

/** 未读占位日（含 9999-12-31T00:00:00 / 9999-12-31 00:00:00） */
export function isSalesLeadUnreadDate(value) {
    if (value == null || value === '') return false;
    const s = String(value).trim();
    if (!s) return false;
    return s === SL_UNREAD_DATE || s.startsWith(SL_UNREAD_DATE) || /^9999[-/.]12[-/.]31/.test(s);
}

export function formatSalesLeadDate(value) {
    if (value == null || value === '') return '';
    const s = String(value).trim();
    if (!s) return '';

    const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;

    const slash = s.match(/^(\d{4})[/.-](\d{1,2})[/.-](\d{1,2})/);
    if (slash) {
        const m = String(slash[2]).padStart(2, '0');
        const d = String(slash[3]).padStart(2, '0');
        return `${slash[1]}-${m}-${d}`;
    }

    const parsed = Date.parse(s);
    if (!Number.isNaN(parsed)) {
        const dt = new Date(parsed);
        if (!Number.isNaN(dt.getTime())) {
            const y = dt.getFullYear();
            const m = String(dt.getMonth() + 1).padStart(2, '0');
            const d = String(dt.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        }
    }

    return s.length >= 10 ? s.slice(0, 10) : s;
}

/** 详情已读日期；未读哨兵或空则返回 ''（勿把 9999-12-31 当查看时间） */
export function formatSalesLeadViewedDate(detail) {
    if (!detail) return '';
    const raw = detail.readDate || detail.ReadDate || '';
    if (!raw || isSalesLeadUnreadDate(raw)) return '';
    const day = formatSalesLeadDate(raw);
    if (!day || day === SL_UNREAD_DATE || day.startsWith('1900-01-01')) return '';
    return day;
}
